var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38.9998,
    height: 23.9675,
    rx: 11.9837,
    fill: "url(#paint0_linear_4901_37709)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38.9998,
    height: 23.9675,
    rx: 11.9837,
    stroke: "url(#paint1_linear_4901_37709)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5531 8.57581L23.3046 13.3415L25.8612 11.2505C25.5568 11.0112 25.3595 10.6411 25.3554 10.2238C25.3479 9.4937 25.9342 8.89559 26.6642 8.8883C27.3944 8.88087 27.9925 9.46711 27.9997 10.1972C28.007 10.9274 27.4211 11.5253 26.6908 11.5328C26.6321 11.5333 26.5742 11.5301 26.5174 11.5232L25.442 16.3685C25.3762 16.6648 25.1207 16.8697 24.8174 16.8697H24.2332H21.2162H18.9907H16.0867H15.3895C15.0862 16.8697 14.8307 16.6648 14.7649 16.3685L13.6771 11.467C13.5683 11.4973 13.454 11.514 13.3357 11.5152C12.6056 11.5225 12.0075 10.9364 12.0001 10.2063C11.9929 9.47615 12.5789 8.87804 13.3091 8.87075C14.0393 8.86346 14.6374 9.44956 14.6445 10.1797C14.6484 10.5636 14.4881 10.911 14.229 11.1552L16.9791 13.4044L19.758 8.5912C19.2145 8.43138 18.815 7.93154 18.809 7.33572C18.8017 6.6056 19.3878 6.00749 20.118 6.00006C20.8481 5.99291 21.4462 6.57901 21.4535 7.30913C21.4594 7.89644 21.0813 8.39804 20.5531 8.57581ZM15.5488 17.5961H24.6919C25.0694 17.5961 25.3774 17.9041 25.3774 18.2816V18.2819C25.3774 18.6595 25.0694 18.9675 24.6919 18.9675H15.5488C15.1712 18.9675 14.8632 18.6595 14.8632 18.2819V18.2816C14.8632 17.9041 15.1712 17.5961 15.5488 17.5961Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4901_37709",
    x1: 2.63157,
    y1: 2.73083,
    x2: 37.9885,
    y2: 7.55163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4901_37709",
    x1: 4.21051,
    y1: -1.17036,
    x2: 46.5903,
    y2: 4.67422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5d8e7cfe66c5e034ceb3271f87163bbb.svg";
export { ForwardRef as ReactComponent };